import { render } from "./OrderOverview.vue?vue&type=template&id=64ecb4ad&scoped=true"
import script from "./OrderOverview.js?vue&type=script&lang=js"
export * from "./OrderOverview.js?vue&type=script&lang=js"

import "./OrderOverview.scss?vue&type=style&index=0&id=64ecb4ad&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./OrderOverview.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Firshadck%2Fprojects%2Fsunrise-spa%2Fsrc%2Fpresentation%2Ffashion%2FPageCheckout%2FOrderOverview%2FOrderOverview.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/irshadck/projects/sunrise-spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ecb4ad"]])

export default __exports__